import { CSSObject } from '@chakra-ui/react';

export const WrapperOnboarding: CSSObject = {
  display: 'grid',
  gridTemplateColumns: ['1fr', null, '300px'],
  gridTemplateRows: ['auto 1fr', null, '1fr'],
  gap: '0px 0px',
  gridAutoFlow: ['row', null, 'unset'],
  gridTemplateAreas: [
    `
    "."
    "."
  `,
    null,
    `
    ". ."
  `,
  ],
  maxH: ['full', null, 'unset'],
  minH: [null, null, '670px'],
  mx: [null, null, 'auto'],
  my: [null, null, 'auto'],
  borderRadius: [null, null, '10px'],
  bg: 'white',
  boxShadow: [null, null, '0px 8px 30px 0px rgba(0, 0, 0, 0.20)'],
  pos: 'relative',
  w: ['100dvw', null, 'unset'],
};

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  my: ['2', null, 'auto'],
  minW: ['auto', null, '460px'],
  '#email': {
    bg: 'gray.50',
    boxShadow: 'unset',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'gray.300',
    color: 'gray.700',
    fontWeight: '400',
    borderRadius: 'lg',
    h: '38px',
    ':hover, :focus': {
      bg: 'gray.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.400',
    },
    _focus: {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.300',
      boxShadow: '0px 2px 8px 0px rgba(66, 153, 225, 0.45)',
    },
  },
};

export const Title: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: '4',
};

export const Input: CSSObject = {
  alignSelf: 'stretch',
  h: '38px',
  '&&': {
    borderRadius: 'lg',
    bg: 'gray.50',
    boxShadow: 'unset',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'gray.300',
    color: 'gray.700',
    fontWeight: 'normal',
    '&&:hover, &&:focus': {
      bg: 'gray.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'gray.400',
    },
    '&&:focus': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'blue.300',

      boxShadow: '0px 2px 8px 0px rgba(66, 153, 225, 0.45)',
    },

    _placeholder: {
      color: 'gray.400',
    },
  },
};
